import { gql } from "@apollo/client";
import axios from "axios";
import { ORGANIZATION_FIELDS_FRAGMENT } from "../../../common/model/fieldsFragment";

export const GET_ORGANIZATION = gql`
  query GetOrganization($organizationId: String!) {
    QR_GET_ORGANIZATION(organizationId: $organizationId) {
      code
      data { ...OrganizationFields }
    }
  }
  ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation UpdateOrganization($organizationId: String!, $organizationInput: OrganizationInput!) {
    MT_UPDATE_ORGANIZATION(organizationId: $organizationId, organizationInput: $organizationInput) {
      code
      data { ...OrganizationFields }
    }
  }
  ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const CREATE_ORGANIZATION_MUTATION = gql`
  mutation CreateOrganization($organizationInput: OrganizationInput!) {
    MT_ADD_ORGANIZATION(organizationInput: $organizationInput) {
      code
      data { ...OrganizationFields }
    }
  }
  ${ORGANIZATION_FIELDS_FRAGMENT}
`;
